import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { View, SafeAreaView, useWindowDimensions, StyleSheet } from 'react-native';
import { useTheme } from '@react-navigation/native';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledCheckbox from '../../../components/ControlledComponents/CustomControlledCheckbox';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';

const FlatListViewSalaryEligibility = React.memo(({ item, index, styles, t, control, convertDate, setValue, colors }) => {
    //#region Variables
    const [selectedData, setSelectedData] = useState([]);
    //#endregion

    //#region UseEffects
    useEffect(() => {
        let fieldDate = item['dateof13thsalaryexception'];
        if (fieldDate !== '' && fieldDate !== null) {
            setSelectedData({ startDate: fieldDate?.split('T')[0] })
        }
        else setSelectedData([]);
    }, [])

    useEffect(() => {
        const dateToSet = selectedData?.startDate ? convertDate(selectedData.startDate) : '';
        setValue(`data[${index}].dateOfThirteenthSalaryException`, dateToSet);
    }, [selectedData]);
    //#endregion

    return (
        <SafeAreaView>
            <SafeAreaView style={styles.row}>
                {/*<CustomLabel value={t(`common:salaryEligibility`)} type='SUBTITLENOFLEX' />
                <CustomControlledCheckbox
                    control={control}
                    name={`data[${index}].exceptionThirteenthSalary`}
                />*/}
            </SafeAreaView>
            <SafeAreaView style={styles.row}>
                <CustomLabel value={t('common:dateOf13thSalaryEligibility')} type='SUBTITLENOFLEX' />
                <CustomControlledInput
                    name={`data[${index}].dateOfThirteenthSalaryException`}
                    control={control}
                    editable={false}
                    // rules={{
                    //     required: 'Date is required',
                    // }}
                    type='MAININPUT'
                />
            </SafeAreaView>
            <View style={{
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 10,
                borderWidth: 0,
                borderColor: colors.border_card,
            }}>
                <CustomCalendar
                    calendarType={'RangePicker'}
                    setRange={setSelectedData}
                    range={selectedData}
                    allowSingleDate={true}
                    startingYear={1950}
                />
            </View>
        </SafeAreaView >
    )
})
const HRAdminSalaryEligibility = ({ props }) => {
    //#region Variables
    const { selectedEmployee, convertDate, flatlistEditPress,
        modal, t, modalVisible, setModalVisible, ActivityIndicator
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const { colors } = useTheme();
    const styles = makeStyles(colors,);
    const { control, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            data: modal.dataArr
        }
    });
    const { updateSalaryEligibility, getLimitedData } = useHRAdminEmployees();
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const [salaryEligibility, setSalaryEligibility] = useState([]);
    //#endregion

    //#region UseEffects
    useEffect(() => {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [state]);

    useEffect(() => {
        setIsLoading(true);
        getLimitedData(selectedEmployee?.employeeID, "mnuEmployee").then((res) => {
            let employeeData = res?.data[0];
            setValue(`data[0].dateOfThirteenthSalaryException`, convertDate(employeeData?.['dateof13thsalaryexception']));
            setValue(`data[0].exceptionThirteenthSalary`, employeeData?.['13thsalaryeligibility']);
            setSalaryEligibility([employeeData]);
            setIsLoading(false);
        })
    }, [])
    //#endregion

    //#region Submit
    const onSubmit = data => {
        setIsLoading(true);
        setState('saving');
        updateSalaryEligibility(data?.data, selectedEmployee?.employeeID).then((res) => {
            getLimitedData(selectedEmployee?.employeeID, "mnuEmployee").then((res) => {
                let employeeData = res?.data[0];
                setValue(`data[0].dateOfThirteenthSalaryException`, convertDate(employeeData?.['dateof13thsalaryexception']));
                setValue(`data[0].exceptionThirteenthSalary`, employeeData?.['13thsalaryeligibility']);
                setSalaryEligibility([employeeData]);
                setIsLoading(false);
                setState('allOperationsSuccMess');
                closeModal();
            })
        })
    };
    //#endregion

    //#region Modal
    const closeModal = () => {
        setModalVisible(!modalVisible);
    }
    //#endregion

    if (isLoading)
        return null;

    return (
        <SafeAreaView style={styles.mainView}>
            <View style={styles.rowRightAlign}>
                {state && showState && <CustomLabel
                    value={`${t('common:state')}: ${t(`common:${state}`)}`}
                    type='EDIT_EMPLOYEE_STATE'
                />}
                <Ionicons
                    name={"close-circle-outline"}
                    style={styles.icon}
                    onPress={closeModal}
                />
            </View>
            <CustomLabel
                value={`${selectedEmployee?.name}'s ${t(`common:${modal?.title}`)}`}
                type='SUBTITLE'
            />
            <View style={styles.horizontalLine} />
            {salaryEligibility.length === 0 ?
                <ActivityIndicator animating={true} color={colors.blue} />
                :
                <FlatListViewSalaryEligibility
                    styles={styles}
                    colors={colors}
                    control={control}
                    item={salaryEligibility[0]}
                    index={0}
                    convertDate={convertDate}
                    setValue={setValue}
                    handleEditPress={flatlistEditPress}
                    t={t}
                />
            }
            <View style={[styles.functionalityButtons]}>
                <CustomButton
                    text={t('common:saveChanges')}
                    onPress={handleSubmit(onSubmit)}
                    type='BUTTON_SAVE'
                    isGradient={true}
                    textTop='0'
                    sz={15}
                />
            </View>
        </SafeAreaView>
    );
};

const makeStyles = (colors) => StyleSheet.create({
    mainView: {
        flex: 1,
        justifyContent: 'space-between'
    },
    row: {
        flexDirection: 'row',
    },
    rowRightAlign: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        padding: 10,
    },
    icon: {
        fontSize: 24,
        color: 'black',
        marginHorizontal: 5,
    },
    horizontalLine: {
        backgroundColor: colors.buttons_primary,
        height: 1,
        marginVertical: "2%",
        marginRight: "1%"
    },
});
export default HRAdminSalaryEligibility;